const pagenavSetup = () => {
  const components = document.querySelectorAll('[data-component-page-nav]');

};
pagenavSetup();


    // for duplicate activity 
    $('.duplicate_item').on('click',function() {
      var data = {
        action: 'rd_duplicate_post_as_draft',
        security: $(this).attr('data-item-nonce'),
        post: $(this).attr('data-item-postid')
      };

      $.ajax({
        url: archeologiedagen_js_vars.url,
        type: "POST",
        data: data,
        dataType: "json",
        success: function(data, textStatus, jqXHR) {
          console.log(data);
          window.location.href = archeologiedagen_js_vars.wp_siteurl+'/beheer-je-activiteit/?actid='+data+'&duplicate=true';
          // redirect io new page
        },
        error: function(jqXHR, textStatus, errorThrown) {

        },
        complete: function(jqXHR, textStatus) {

        },

      });

    });



    // for delete activity 
    $('.delete_item').on('click',function() {

      var result = confirm("Weet je zeker dat je deze activiteit wilt verwijderen?");

      if (result) {

         var postid = $(this).attr('data-item-postid');
         var data = {
          action: 'rd_delete_post',
          security: $(this).attr('data-item-nonce'),
          post: postid
        };

        $.ajax({
          url: archeologiedagen_js_vars.url,
          type: "POST",
          data: data,
          dataType: "json",
          success: function(data, textStatus, jqXHR) {
            console.log('yeshide');
            $('#act_row_'+postid).fadeOut();
          },
          error: function(jqXHR, textStatus, errorThrown) {

          },
          complete: function(jqXHR, textStatus) {
       
          },
       
        });
      }
    });
